import axios from 'axios';

const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientPayments = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientPayments.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClientPayments.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export const resolveProductImageUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL();
  // Ensure base ends with '/' and path starts with '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}api/payments${normalizedPath}`;
};

// Genel payments dosya URL çözümleyici (örn. /api/payments/files/DonationCards/...)
export const resolvePaymentsFileUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL();
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  // ProductDetail ile aynı pattern: base + 'api/payments' + path
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}api/payments${normalizedPath}`;
};

export default httpClientPayments;
